import { APIHandler } from "utilities/apiHandler";

import {
    CanSendProductsToCartResponse,
    type ISendToCartRequest,
    SendToCartResponse,
    VendorProductInventoryResponse,
} from "entity/vendor/common/vendor.types";

export interface IVendorProductsHandler {
    canSendVendorProductsToCart(data: ISendToCartRequest): Promise<CanSendProductsToCartResponse>;
    sendVendorProductsToCart(data: ISendToCartRequest): Promise<SendToCartResponse>;
    getInventoryInformation(vendorProductIds: number[]): Promise<VendorProductInventoryResponse>;
}

export class VendorProductsHandler implements IVendorProductsHandler {
    async canSendVendorProductsToCart(
        data: ISendToCartRequest,
    ): Promise<CanSendProductsToCartResponse> {
        return await APIHandler("/api/VendorProducts/CanSendProductsToCart", {
            method: "POST",
            data,
            responseType: CanSendProductsToCartResponse,
        });
    }

    async sendVendorProductsToCart(data: ISendToCartRequest): Promise<SendToCartResponse> {
        return await APIHandler("/api/VendorProducts/SendToCart", {
            method: "POST",
            data,
            responseType: SendToCartResponse,
        });
    }

    async getInventoryInformation(
        vendorProductIds: number[],
    ): Promise<VendorProductInventoryResponse> {
        return await APIHandler("/api/VendorProducts/Inventory", {
            method: "GET",
            data: { vendorProductIds: Array.from(new Set(vendorProductIds)).join(",") },
            responseType: VendorProductInventoryResponse,
        });
    }
}
